import { cn } from 'utils/classNames';
import { round } from 'utils/math';

import {
	ANIMATION_DURATIONS,
	type AnimationDuration,
	type Orientation,
	useOrientationData,
} from './helpers';

export default function ProgressTracker({
	animationDuration,
	containerSize,
	gutter,
	orientation,
	scrollPos,
	totalSize,
}: {
	animationDuration: AnimationDuration;
	containerSize: number;
	gutter: number;
	orientation: Orientation;
	scrollPos: number;
	totalSize: number;
}) {
	const size = (containerSize / (totalSize || 1)) * 100;
	const pos = size * (scrollPos / ((containerSize || 1) - gutter));
	const { isHorizontal, isVertical, sizeProp, translateProp } =
		useOrientationData(orientation);

	return (
		<div
			className={cn(
				'relative overflow-hidden rounded-full bg-strong/15 forced-colors-outline',
				isHorizontal && 'h-1 w-full max-w-[250px]',
				isVertical && 'h-[200px] w-1',
			)}
		>
			<div
				style={{ transform: `${translateProp}(${round(pos)}%)` }}
				className={cn(
					'h-full w-full',
					ANIMATION_DURATIONS[animationDuration].time !== 0 && [
						'transition-transform motion-reduce:transition-none',
						ANIMATION_DURATIONS[animationDuration].className,
					],
				)}
			>
				<div
					style={{ [sizeProp]: `${round(size)}%` }}
					className={cn(
						'rounded-full bg-strong forced-color-adjust-none forced-colors:bg-[CanvasText]',
						isHorizontal && 'h-1',
						isVertical && 'w-1',
					)}
				/>
			</div>
		</div>
	);
}
ProgressTracker.displayName = 'Carousel_ProgressTracker';
